// src/service/ResetPasswordService.js
import { apiClient } from "./ApiClient"; // adjust path if needed

/** ---------------------------
 *  RESET PASSWORD
 * --------------------------- */
export const resetPasswordAPI = async (token, newPassword) => {
  const payload = {
    action: "updatePwd",
    token,
    newPassword,
  };

  const response = await apiClient.post("register", payload);
  return response;
};

/** ---------------------------
 *  USER REGISTRATION
 * --------------------------- */
export const registerUserAPI = async (userData) => {
  const payload = {
    action: "register",
    ...userData, // name, email, username, password, etc.
  };

  const response = await apiClient.post("register", payload);
  return response;
};